import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/free-solid-svg-icons';
import MenuFooter from './Component/MenuFooter';
import ArrowLeft from './images/ArrowLeft.png';

const Orders = () => {
  const navigate = useNavigate();
  const [liveRfqs, setLiveRfqs] = useState([]);
  const [closedRfqs, setClosedRfqs] = useState([]); 
  const [loadingRfqs, setLoadingRfqs] = useState(false);
  const [activeTab, setActiveTab] = useState('live');

  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES || '';
  const API_BASE = process.env.REACT_APP_FORE_BRICKBUCKET;

  useEffect(() => {
    fetchLiveRfqs();
  }, []);

  const fetchLiveRfqs = async () => {
    try {
      setLoadingRfqs(true);

      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const userId = userData?._id;
      const token = userData?.token || sessionStorage.getItem('token');
      if (!userId) return;

      const res = await fetch(
        `${API_BASE}customer/rfq/get-rfqs-by-customer?customerId=${userId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token || '',
          },
        }
      );

      const data = await res.json();
      console.log('Live RFQs fetched', data);

      if (data.success && Array.isArray(data.data)) {
        const reversedData = [...data.data].reverse();
        setLiveRfqs(reversedData);
      } else {
        setLiveRfqs([]);
        console.warn('fetchLiveRfqs: data.data is not an array', data.data);
      }
    } catch (err) {
      console.error('fetchLiveRfqs', err);
      setLiveRfqs([]);
    } finally {
      setLoadingRfqs(false);
    }
  };

  const filteredOrders = activeTab === 'live' ? liveRfqs : closedRfqs;

 const handleOrderClick = (order) => {
  if (!order.rfq_for_project && order.itemsList && order.itemsList.length > 0) {
    const item = order.itemsList[0][0]; 
    const quotationId = item?.quotation_id;

    if (quotationId) {
      navigate("/consumer/app/orderdetails", {
        state: { quotationId },
      });
    }
  }
};


  if (loadingRfqs) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading RFQs...</p>
      </div>
    );
  }

 return (
  <div className="min-h-screen flex flex-col bg-gray-50">
    {/* Header */}
    <div className="w-full px-1 py-4 border-b border-gray-200 bg-white sticky top-0 z-40 items-center">
      <div className="flex items-center">
        <img
          src={ArrowLeft}
          className="w-10 h-6 cursor-pointer"
          alt="Back"
          onClick={() => navigate('/consumer/projectdetails')}
        />
        <h1 className="text-[#000000] font-medium text-md ml-2">RFQ</h1>
      </div>
    </div>

    {/* Tabs */}
    <div className="flex gap-8 mt-3 px-6">
      <button
        className={`pb-2 text-sm font-medium ${
          activeTab === 'live'
            ? 'text-black border-b-[3px] w-10 border-[#DE1B52]'
            : 'text-gray-400'
        }`}
        onClick={() => setActiveTab('live')}
      >
        Live
      </button>
      <button
        className={`pb-2 text-sm font-medium ${
          activeTab === 'closed'
            ? 'text-black border-b-[3px] w-10 border-[#DE1B52]'
            : 'text-gray-400'
        }`}
        onClick={() => setActiveTab('closed')}
      >
        Closed
      </button>
    </div>

    {/* Main Content */}
    <div className="flex-1 p-4">
      <div className="space-y-3 mx-2 mt-2 mb-16">
        {filteredOrders && filteredOrders.length > 0 ? (
          filteredOrders.map((order) => {
            const lastItemArray =
              !order.rfq_for_project && order.itemsList && order.itemsList.length > 0
                ? order.itemsList[order.itemsList.length - 1]
                : [];

            return (
              <div
                key={order._id}
                className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-sm transition-shadow cursor-pointer mb-4"
              >
                {/* Top Section */}
                <div className="flex items-start justify-between mb-3">
                  <div className="flex flex-col mb-1">
                    <div className="flex items-center gap-5">
                      <h3 className="text-md font-medium text-[#524D4D]">
                        {order.rfq_number}
                      </h3>
                    </div>
                    <p className="text-[10px] text-[#000000] mt-0.1">
                      {new Date(order.createdAt).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      })}
                    </p>
                  </div>

                  {!order.rfq_for_project && (
                    <div className="text-right">
                      <p className="text-md font-semibold text-[#170101]">
                        ₹
                        {lastItemArray.reduce(
                          (sum, item) => sum + (item.total || 0),
                          0
                        ).toLocaleString()}
                      </p>
                    </div>
                  )}
                </div>

                {/* Images */}
                <div className="mb-3 pb-3 border-b border-gray-200">
                  {order.rfq_for_project ? (
                    order.material_requirements &&
                    order.material_requirements.length > 0 ? (
                      <div className="mb-3 flex gap-2 overflow-x-auto">
                        {order.material_requirements.map((imgPath, idx) => (
                          <img
                            key={idx}
                            src={`${API_BASE}${
                              imgPath.startsWith('/') ? imgPath.slice(1) : imgPath
                            }`}
                            alt={`Material ${idx + 1}`}
                            className="w-20 h-20 object-cover rounded"
                          />
                        ))}
                      </div>
                    ) : (
                      <span className="text-xs text-gray-400">
                        No Material Requirements
                      </span>
                    )
                  ) : (
                    <div className="flex gap-2">
                      {lastItemArray.slice(0, 4).map((item, index) => (
                        <div
                          key={item._id || index}
                          className="w-12 h-12 rounded bg-[#F5F0F0] flex items-center justify-center"
                        >
                          <img
                            src={`${imageUrl}${item.item_image}`}
                            alt={item.item_name || `Item ${index + 1}`}
                            className="w-8 h-8 object-cover rounded"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.parentNode.innerHTML +=
                                '<span class="text-xs text-center text-gray-400">No Image</span>';
                            }}
                          />
                        </div>
                      ))}

                      {lastItemArray.length > 4 && (
                        <div className="w-12 h-12 rounded bg-[#F5F0F0] flex items-center justify-center">
                          <span className="text-xs font-medium text-gray-600">
                            +{lastItemArray.length - 4}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Status + View */}
             <div className="flex justify-between items-center mt-2">
  <span className="text-gray-600 text-xs font-medium">
    {order.status}
  </span>
  <button
    className="text-[#DE1B52] font-semibold text-xs hover:underline"
    onClick={() => {
      if (!order.rfq_for_project) {
        handleOrderClick(order);
      }
    }}
  >
    View Details
  </button>
</div>


              </div>
            );
          })
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faBox} className="text-gray-400 text-xl" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {activeTab === 'live' ? 'No Live RFQs' : 'No Expired RFQs'}
            </h3>
            <p className="text-gray-500 text-sm">
              {activeTab === 'live'
                ? "You don't have any active RFQs"
                : "You don't have any expired RFQs"}
            </p>
          </div>
        )}
      </div>
    </div>

    <div className="fixed bottom-0 left-0 right-0 z-50">
      <MenuFooter />
    </div>
  </div>
);


};

export default Orders;
